import React, { useCallback, useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { ApplicationState } from '../../../../store';
import { EOrderSettingsRoutes } from '../OrderSettings/orderSettings.routes';
import { Container, TitleBox } from './styles';
import { Title } from '@gerdau/hefesto';
import { StepByStep } from '@gerdau/hefesto-mais-web';
import { Step } from '@gerdau/hefesto-mais-web/StepByStep/StepByStep.types';
import { BreadcrumbItemProps } from '@gerdau/hefesto-mais-web/Breadcrumbs/Breadcrumbs.types';
import { PurchaseSubHeaderStepEnum } from './enum/PurchaseSubHeaderStepEnum';
import NavegationMenuBar from '../../../../components/NavegationMenuBar';
import { EPurchaseRoutes } from '../../purchase.routes';
import { ELocalStorageKey } from '../../../../services/EGerdauService/types';

const PurchaseSubHeader: React.FC = () => {
  const { pathname } = useLocation();

  const itemNavBuy = {
    name: 'Comprar',
    url: `${EPurchaseRoutes.STEEL_TYPE_CHOOSE}`
  };
  const itemNavBuyLongSteel = {
    name: 'Comprar aços longos',
    url: `${EOrderSettingsRoutes.ENTRY_TYPE}`
  };
  const itemNavBuySelectingItems = {
    name: 'Comprar selecionando items',
    url: '/'
  };
  const itemNavBuyBySheet = {
    name: 'Comprar via planilha',
    url: '/'
  };
  const itemNavBuyByHistory = {
    name: 'Comprar com base no histórico',
    url: '/'
  };

  const [menuLinks, setMenuLinks] = useState<BreadcrumbItemProps[]>([]);

  const shoppingCart = useSelector(
    (state: ApplicationState) => state.longSteelShoppingCart
  );

  const steps: Step[] = [
    { label: PurchaseSubHeaderStepEnum.SELECT_ITEMS },
    { label: PurchaseSubHeaderStepEnum.DETAILING },
    { label: PurchaseSubHeaderStepEnum.REVIEW_ORDER },
    { label: PurchaseSubHeaderStepEnum.SEND_FOR_ANALYSIS }
  ];

  const [currentStep, setCurrentStep] = useState(0);
  const [canShowSubHeader, setCanShowSubHeader] = useState(false);

  useEffect(() => {
    if (pathname.includes(EOrderSettingsRoutes.ENTRY_TYPE)) {
      setMenuLinks([itemNavBuy, itemNavBuyLongSteel]);
      return;
    }

    if (pathname.includes(EOrderSettingsRoutes.SEARCH_ITEMS)) {
      setMenuLinks([itemNavBuy, itemNavBuyLongSteel, itemNavBuySelectingItems]);
      return;
    }

    setMenuLinks([itemNavBuy, itemNavBuyLongSteel]);
  }, [currentStep, pathname]);

  useEffect(() => {
    if (pathname.includes(EOrderSettingsRoutes.ENTRY_TYPE)) {
      updateMenuLinks([itemNavBuy, itemNavBuyLongSteel]);
      return;
    }

    if (pathname.includes(EOrderSettingsRoutes.SEARCH_ITEMS)) {
      updateMenuLinks([
        itemNavBuy,
        itemNavBuyLongSteel,
        itemNavBuySelectingItems
      ]);
      return;
    }

    if (pathname.includes(EOrderSettingsRoutes.REPEAT_ORDER)) {
      updateMenuLinks([itemNavBuy, itemNavBuyLongSteel, itemNavBuyByHistory]);
      return;
    }

    if (pathname.includes(EOrderSettingsRoutes.SPREADSHEET_UPLOAD)) {
      updateMenuLinks([itemNavBuy, itemNavBuyLongSteel, itemNavBuyBySheet]);
      return;
    }

    // Caso o usuário atualize a página
    const menuLinksCache =
      localStorage.getItem(ELocalStorageKey.LONG_STEEL_MENU_NAVEGATION) ?? '';
    if (
      menuLinksCache &&
      (typeof menuLinksCache === 'object' ||
        typeof menuLinksCache === 'function')
    ) {
      updateMenuLinks(JSON.parse(menuLinksCache));
    }
  }, [pathname]);

  const updateMenuLinks = (items: BreadcrumbItemProps[]) => {
    setMenuLinks(items);
    localStorage.setItem(
      ELocalStorageKey.LONG_STEEL_MENU_NAVEGATION,
      JSON.stringify(items)
    );
  };

  const updateCurrentStep = useCallback(() => {
    if (
      pathname.includes(EOrderSettingsRoutes.SEARCH_ITEMS) ||
      pathname.includes(EOrderSettingsRoutes.SPREADSHEET_UPLOAD) ||
      pathname.includes(EOrderSettingsRoutes.ENTRY_TYPE)
    ) {
      setCurrentStep(0);
    } else if (pathname.includes(EOrderSettingsRoutes.SHOPPING_CART)) {
      setCurrentStep(1);
    } else if (pathname.includes(EOrderSettingsRoutes.CHECKOUT)) {
      if (shoppingCart.createdOrders && shoppingCart.createdOrders.length > 0) {
        setCurrentStep(4);
      } else {
        setCurrentStep(2);
      }
    }
  }, [pathname, shoppingCart.createdOrders]);

  useEffect(() => {
    if (pathname) {
      updateCurrentStep();
      setCanShowSubHeader(!pathname.includes(EOrderSettingsRoutes.ENTRY_TYPE));
    }
  }, [pathname, updateCurrentStep]);

  return (
    <>
      <Container>
        <TitleBox>
          <NavegationMenuBar items={menuLinks}></NavegationMenuBar>
          <Title level={1}>Comprar aços longos</Title>
          {!canShowSubHeader && (
            <span>Como você gostaria de realizar a compra?</span>
          )}
        </TitleBox>
        {canShowSubHeader && (
          <StepByStep steps={steps} activeStep={currentStep}></StepByStep>
        )}
      </Container>
    </>
  );
};

export default PurchaseSubHeader;
